// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__35wN0","content":"Card_content__1AEDp","img":"Card_img__1qgJC","badge":"Card_badge__21uzr"};